import type { PropsWithChildren } from 'react';
import React from 'react';
import { Box } from '@mui/material';
import { LoadingSpinner } from 'c-components';
import ReportLoadFailed from 'c-reports/Components/ReportLoadFailed';

type Props = PropsWithChildren<{
    loading: boolean;
    /**
     * The summary request failed: one error for the section, not "No Data" in every widget. It
     * outranks `loading`, whose stale-filters flag only clears on a successful load, so a failed
     * first load would otherwise spin forever. A Retry in flight is InProgress, not failed.
     */
    failed: boolean;
    onRetry: () => void;
}>;

/** The Summary tab's widgets, or the spinner / error in their place. */
const SummaryWidgetsBody: React.FC<Props> = ({ loading, failed, onRetry, children }) => {
    if (failed) {
        return (
            <Box minHeight={300}>
                <ReportLoadFailed onRetry={onRetry} />
            </Box>
        );
    }
    if (loading) {
        return (
            <Box minHeight={500} position="relative">
                <Box
                    position="absolute"
                    top="50%"
                    left="50%"
                    sx={{ transform: 'translate(-50%, -50%)' }}
                >
                    <LoadingSpinner />
                </Box>
            </Box>
        );
    }
    return <>{children}</>;
};

export default SummaryWidgetsBody;
